// @flow
import React from 'react';
import type { Element } from 'react';

import { Link } from '@i18n';

import type { Props } from '../../types';

export default (props: Props): Element<any> => {
  const { href }: Props = props;

  if (href) {
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */
    if (href.startsWith('http')) return <a {...props} />;

    return (
      <Link href={href} passHref>
        {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
        <a {...props} />
      </Link>
    );
  }

  // eslint-disable-next-line jsx-a11y/anchor-has-content
  return <a {...props} />;
};
